import Immutable from 'immutable';
import {
  CLEAR_DRIVER_TASK_SUMMARY,
  FLAG_GETTING_DRIVER_TASK_SUMMARY_MONTHLY,
  FLAG_GETTING_DRIVER_TASK_SUMMARY_MOVEMENTS,
  GET_DRIVER_TASK_SUMMARY_MONTHLY,
  GET_DRIVER_TASK_SUMMARY_MOVEMENTS,
} from '../../../actions/types/traffic/DriverTaskSummary';

const INITIAL_STATE = Immutable.Map({
  movements: Immutable.Map({
    content: Immutable.List(),
    loading: false,
  }),
  monthly: Immutable.Map({
    content: Immutable.List(),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_DRIVER_TASK_SUMMARY_MOVEMENTS:
      return state.setIn(['movements', 'loading'], payload);
    case GET_DRIVER_TASK_SUMMARY_MOVEMENTS:
      return state.setIn(['movements', 'content'], Immutable.List(payload));
    case FLAG_GETTING_DRIVER_TASK_SUMMARY_MONTHLY:
      return state.setIn(['monthly', 'loading'], payload);
    case GET_DRIVER_TASK_SUMMARY_MONTHLY:
      return state.setIn(['monthly', 'content'], Immutable.List(payload));
    case CLEAR_DRIVER_TASK_SUMMARY:
      return INITIAL_STATE;
    default:
      return state;
  }
};